/** @jsxImportSource react */
import { Box, Paper, Typography } from '@mui/material'
import FieldInput from './FieldInput'

/** Renders a published form definition: sections → fields laid out in the section's columns. */
/** `lookups`: the record's resolved LOOKUP values (titles of linked records). */
const DynamicForm = ({ form, values, onChange, errors = {}, disabled, lookups = {} }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    {form.sections.map((section) => {
      const fields = section.fields.filter((f) => !f.hidden)
      if (fields.length === 0) return null
      return (
        <Paper key={section.id} variant="outlined" sx={{ p: { xs: 2, sm: 2.5 } }}>
          <Typography variant="subtitle2">{section.title}</Typography>
          {section.description && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {section.description}
            </Typography>
          )}
          <Box
            sx={{
              mt: 2,
              display: 'grid',
              gap: 2,
              gridTemplateColumns: { xs: '1fr', md: `repeat(${section.columns || 1}, minmax(0, 1fr))` },
            }}
          >
            {fields.map((field) => (
              <Box key={field.fieldKey} sx={field.fieldType === 'TEXTAREA' ? { gridColumn: '1 / -1' } : undefined}>
                <FieldInput
                  field={field}
                  value={values[field.fieldKey]}
                  onChange={(value) => onChange(field.fieldKey, value)}
                  error={errors[field.fieldKey]}
                  disabled={disabled}
                  lookupRef={lookups[field.fieldKey]}
                />
              </Box>
            ))}
          </Box>
        </Paper>
      )
    })}
  </Box>
)

export default DynamicForm
